import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Services from './components/Services';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

function App() {
  const [isOpening, setIsOpening] = useState(true);
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(8);

  const finishOpening = useCallback(() => {
    setIsVideoReady(true);
  }, []);

  useEffect(() => {
    if (!isOpening) {
      return;
    }

    const progressTimer = window.setInterval(() => {
      setLoadingProgress((prev) => {
        if (isVideoReady) {
          return 100;
        }
        return Math.min(prev + 1.8, 92);
      });
    }, 90);

    return () => window.clearInterval(progressTimer);
  }, [isOpening, isVideoReady]);

  useEffect(() => {
    const fallbackReadyTimer = window.setTimeout(() => {
      setIsVideoReady(true);
    }, 5200);

    return () => window.clearTimeout(fallbackReadyTimer);
  }, []);

  useEffect(() => {
    if (!isVideoReady) {
      return;
    }

    setLoadingProgress(100);
    const closeTimer = window.setTimeout(() => {
      setIsOpening(false);
    }, 380);

    return () => window.clearTimeout(closeTimer);
  }, [isVideoReady]);

  return (
    <div className="App">
      <AnimatePresence>
        {isOpening && (
          <motion.div
            className="opening-loader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.5, ease: 'easeOut' } }}
          >
            <div className="opening-loader__content">
              <div className="opening-loader__brand">Kaçkar Karafırın</div>
              <div className="opening-loader__subtitle">Lezzet hazırlanıyor</div>
              <div className="opening-loader__icons" aria-hidden="true">
                {['🥖', '🍪', '🧁', '🥐', '🍰'].map((icon, index) => (
                  <motion.span
                    key={`${icon}-${index}`}
                    className="opening-loader__icon"
                    animate={{ y: [0, -6, 0], opacity: [0.7, 1, 0.7] }}
                    transition={{ duration: 1.4, repeat: Infinity, delay: index * 0.14 }}
                  >
                    {icon}
                  </motion.span>
                ))}
              </div>
              <div
                className="opening-loader__bar"
                style={{ ['--loader-progress' as string]: `${loadingProgress}%` }}
              >
                <motion.div
                  className="opening-loader__bar-fill"
                  animate={{ width: `${loadingProgress}%` }}
                  transition={{ duration: 0.22, ease: 'linear' }}
                />
                <span className="opening-loader__bar-bread" aria-hidden="true">
                  🥖
                </span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <Navigation />
      <Hero onVideoReady={finishOpening} />
      <About />
      <Products />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
